import { Component } from '@angular/core';

@Component({
    selector: 'app-table-header-layout',
    templateUrl: './table-header-layout.component.html',
    styleUrls: ['./table-header-layout.component.scss'],
    standalone: false
})
export class TableHeaderLayoutComponent {}
